import React from "react";
import styled from "styled-components";

const SidebarCollapse = styled.div`
  padding-top: 0;
`;

export default SidebarCollapse;


// WEBPACK FOOTER //
// ./src/views/AppViews/Sidebar/components/Nav/SidebarCollapse/index.jsx